import {CLAIMS_DEFAULT_CLINIC_ID} from '../actions/Index';

const initState = {
  claimsDefaultClinicId: null,
  claimsDefaultFilters: null
};
export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case CLAIMS_DEFAULT_CLINIC_ID:
      return {
        ...state,
        claimsDefaultClinicId: payload.claimsDefaultClinicId,
        claimsDefaultFilters: payload.claimsDefaultFilters
      };
    default:
      return state;
  }
}
